import { render, staticRenderFns } from "./DeleteSlot.vue?vue&type=template&id=066bf402&"
import script from "./DeleteSlot.vue?vue&type=script&lang=js&"
export * from "./DeleteSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports